const Vue = require("vue")

import InternalFlight from "./InternalFlight.vue"
import ExternalFlight from "./ExternalFlight.vue"

Array.from(document.querySelectorAll(".js-flight-section")).forEach(item => {
  new Vue({
    el: item,

    components: {
      InternalFlight,
      ExternalFlight,
    },

    data() {
      return {
        isLoaded: true,
      }
    },   
  })
})